import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"] as const;

/**
 * Calls `onActivity` whenever the user interacts with the page.
 * Throttles localStorage writes to avoid excessive I/O.
 */
export function useActivityTracker(onActivity: () => void, throttleMs: number = 5000) {
    const throttleRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const handle = () => {
            if (!throttleRef.current) {
                onActivity();
                throttleRef.current = setTimeout(() => {
                    throttleRef.current = null;
                }, throttleMs);
            }
        };

        ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, handle));

        return () => {
            ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, handle));
            if (throttleRef.current) clearTimeout(throttleRef.current);
        };
    }, [onActivity, throttleMs]);
}
